import apiClient from "../../api/apiClient";
import { API_ENDPOINTS } from "../../api/endPoints";

export interface Location {
  PK: string;
  neighborhood: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
  population: number;
  timezone: string;
  vectorStoreId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getLocations = async (): Promise<Location[]> => {
  const response = await apiClient.get(API_ENDPOINTS.PUBLISHER.LOCATIONS.LIST);
  return response.data;
};